module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/data-bg-2.57b21222.png";